import { Rpc } from '../rpc';
import { RpcOutboundClient } from '../rpc-outbound-client';
import { RpcForwardDownKey, RpcForwardReportData, RpcForwardResponse } from './rpc-forward-model';

export class RpcForwardDownClient {
    /**
     * The Rpc forward down command.
     *
     * @param data the forward report data object.
     * @return Promise<RpcForwardResponse<T>> the promise object of forward response.
     */
    public static forward<T>(rpc: Rpc, data: RpcForwardReportData): Promise<RpcForwardResponse<T>> {
        return RpcOutboundClient.call(rpc, RpcForwardDownKey.command, RpcForwardDownKey.version, data);
    }
}
